import {
  useV2CreateQuestionnaireCalculationMutation,
  useV2UpdateQuestionnaireCalculationMutation,
  useV2DeleteQuestionnaireCalculationMutation,
} from "@generated";
import type { V2QuestionnaireCalculationResource } from "@generated";
import type { CalculationFormValues } from "../types";

export const buildCalculationData = (
  values: CalculationFormValues,
  id?: string
): V2QuestionnaireCalculationResource =>
  ({
    type: "questionnaire-calculations",
    ...(id ? { id: Number(id) } : {}),
    attributes: { name: values.name, expression: values.expression },
  } as unknown as V2QuestionnaireCalculationResource);

export const useCalculationMutations = (questionnaireId: string) => {
  const [create] = useV2CreateQuestionnaireCalculationMutation();
  const [update] = useV2UpdateQuestionnaireCalculationMutation();
  const [destroy] = useV2DeleteQuestionnaireCalculationMutation();
  const qid = Number(questionnaireId);

  return {
    create: (values: CalculationFormValues) =>
      create({
        questionnaireId: qid,
        body: { data: buildCalculationData(values) },
      }).unwrap(),
    update: (id: string, values: CalculationFormValues) =>
      update({
        questionnaireId: qid,
        id: Number(id),
        body: { data: buildCalculationData(values, id) },
      }).unwrap(),
    remove: (id: string) =>
      destroy({ questionnaireId: qid, id: Number(id) }).unwrap(),
  };
};

export default useCalculationMutations;
